<mat-nav-list class="si-list-group-selectable">
  <ng-container *ngFor="let choice of choices;">
    <a
      mat-list-item
      href=""
      (appClickStopPrevent)="makeSelection(choice)"
      [activated]="selectedItem?.name === choice?.name || (selectedItem?.name === 'createApp' && choice?.name === 'exportApps')"
      *ngIf="!choice?.hidden"
    >{{ choice?.title }}</a>
  </ng-container>
</mat-nav-list>
